import { render, staticRenderFns } from "./dr-stepper-component.vue?vue&type=template&id=7c06ecfe&"
import script from "./dr-stepper-component.vue?vue&type=script&lang=js&"
export * from "./dr-stepper-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports